import React, { useEffect } from "react";
import GameHeader from './game-header';
import { global_var } from '../../services/cs-lab-config';
import { sendExceptionNotification } from "../../services/ide-apis";

const CodeCompatGame = () => {

  document.title = "CS Lab | CodeCombat Game";

  useEffect(() => {
    const checkUrl = async () => {
      try {
        const response = await fetch(global_var.CODE_COMPAT_ENDPOINT + 'healthcheck');
        if (response.status !== 200) {
          sendExceptionNotification({
            errorInfo: 'Health check failed',
            errorTitle: 'Failed to load Code Combact'
          });
        }
      } catch (error) {
        sendExceptionNotification({
          errorInfo: 'Health check failed',
          errorTitle: 'Failed to load Code Combact'
        });
      }
    };

    if (global_var.CODE_COMPAT_ENDPOINT) {
      checkUrl();
    }
  }, []);

  return (
    <div className="container-fluid p-0">
      <div className="row mt-1">
        <div className="col">
          <GameHeader headerName="CodeCombat Game" />
          <iframe
            id="CodeCombatIframe"
            src={global_var.CODE_COMPAT_ENDPOINT + 'play'} // Use GBIRD_URL from the global_var object
            title="CodeCombat Game"
            //css code set the iframe window
            style={{
              width: '100%',
              height: '100vh',
              border: 'none',
            }}
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default CodeCompatGame;
